import { useEffect } from 'react';

function ScrollIntoViewController({ menuRef, highlightedIndex, flatFilteredOptions, listboxId }) {
  useEffect(() => {
    if (!menuRef.current || highlightedIndex < 0) return;
    const optionValue = flatFilteredOptions[highlightedIndex]?.value;
    if (optionValue == null) return;
    const el = document.getElementById(`${listboxId}-option-${optionValue}`);
    el?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }, [highlightedIndex, listboxId, flatFilteredOptions, menuRef]);

  return null;
}

export default ScrollIntoViewController;
